import React, { Component } from 'react';
import { HashRouter, Route, Switch,  Link} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'
import Home from './Home';
import PaySlip from './PaySlip';
import UploadMarks from './UploadMarks';
import LeaveApplication from './LeaveApplication';





class ContentArea extends Component {

   constructor(props) {
    super(props);


     this.state={
      user_details:this.props.user_details,
      access_token:this.props.access_token,
      app_data:this.props.app_data


     }
  }
  render() {
    const _this=this;


    return (
        <div>

            <Switch>
              <Route
                    exact path="/staff_ui"
                    render={(props) => <Home {...props}
                                                              staff_details = {_this.props.staff_details}
                                                              base_url={_this.props.base_url}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStaffDetails={_this.props.updateStaffDetails}/> }
              />
              <Route
                    path="/staff_ui/home"
                    render={(props) => <Home {...props}
                                                            staff_details = {_this.props.staff_details}
                                                            base_url={_this.props.base_url}
                                                            loginStatus= {this.props.loginStatus}
                                                            updateStaffDetails={_this.props.updateStaffDetails}/> }
              />

            <Route
                    path="/staff_ui/payslip"
                    render={(props) => <PaySlip {...props} staff_details = {_this.props.staff_details}
                                                              base_url={_this.props.base_url}
                                                              renderInThousands = {this.props.renderInThousands}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStaffDetails={_this.props.updateStaffDetails}/> }
              />

            <Route
                    path="/staff_ui/upload_marks"
                    render={(props) => <UploadMarks {...props} staff_details = {_this.props.staff_details}
                                                              base_url={_this.props.base_url}
                                                              renderInThousands = {this.props.renderInThousands}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStaffDetails={_this.props.updateStaffDetails}/> }
              />

            <Route
                    path="/staff_ui/leave"
                    render={(props) => <LeaveApplication {...props} staff_details = {_this.props.staff_details}
                                                              base_url={_this.props.base_url}
                                                              renderInThousands = {this.props.renderInThousands}
                                                              loginStatus= {this.props.loginStatus}
                                                              updateStaffDetails={_this.props.updateStaffDetails}/> }
              />



            </Switch>
            </div>




    );
  }




}

export default ContentArea;
